import { styled } from '@mui/material/styles';

export const Styles = {
  Overlay: styled('div')`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  `,

  ModalContent: styled('div')`
    position: relative;
    max-width: 85vw;
    max-height: 82vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `,

  ModalImage: styled('img')`
    max-width: 85vw;
    max-height: 70vh;
    object-fit: contain;
    border-radius: 8px 8px 0 0;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  `,

  CaptionContainer: styled('div')`
    width: 100%;
    max-width: 85vw;
    display: flex;
    align-items: center;
    gap: 10px;
    background: rgba(0, 0, 0, 0.7);
    padding: 10px 16px;
    border-radius: 0 0 8px 8px;
    box-sizing: border-box;
  `,

  CaptionLabel: styled('label')`
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
  `,

  CaptionInput: styled('input')`
    flex: 1;
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 6px;
    color: #fff;
    font-size: 13px;
    padding: 6px 10px;
    outline: none;
    transition: border-color 0.2s;

    &:focus {
      border-color: #007bff;
    }

    &::placeholder {
      color: rgba(255, 255, 255, 0.4);
    }
  `,

  CloseButton: styled('button')`
    position: fixed;
    top: 20px;
    right: 20px;
    background: rgba(255, 255, 255, 0.9);
    color: #333;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    font-size: 24px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;
    z-index: 10000;

    &:hover {
      background: #ffffff;
    }
  `,

  NavButton: styled('button')<{ $position: 'left' | 'right' }>`
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    ${({ $position }) =>
      $position === 'left' ? 'left: 10px;' : 'right: 10px;'}
    background: rgba(255, 255, 255, 0.9);
    color: #333;
    border: none;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    font-size: 24px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;
    z-index: 10000;

    &:hover {
      background: #ffffff;
    }

    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  `,

  ImageCounter: styled('div')`
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.6);
    color: #ffffff;
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 14px;
    z-index: 10000;
  `,

  WatermarkToolbar: styled('div')`
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    background: rgba(0, 0, 0, 0.65);
    padding: 10px 16px;
    border-radius: 12px;
    z-index: 10000;
    min-width: 540px;
  `,

  WatermarkLabel: styled('span')`
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    margin-right: 4px;
    opacity: 0.85;
  `,

  WatermarkButton: styled('button')<{ $active: boolean }>`
    background: ${({ $active }) =>
      $active ? '#007bff' : 'rgba(255,255,255,0.15)'};
    color: #ffffff;
    border: 1px solid
      ${({ $active }) => ($active ? '#007bff' : 'rgba(255,255,255,0.35)')};
    border-radius: 6px;
    padding: 4px 10px;
    font-size: 11px;
    cursor: pointer;
    transition:
      background 0.15s,
      border-color 0.15s;
    white-space: nowrap;

    &:hover {
      background: ${({ $active }) =>
        $active ? '#0062cc' : 'rgba(255,255,255,0.28)'};
    }
  `,

  WatermarkToolbarRow: styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
  `,

  WatermarkSliderLabel: styled('span')`
    color: rgba(255, 255, 255, 0.85);
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
    min-width: 80px;
  `,

  WatermarkSlider: styled('input')`
    -webkit-appearance: none;
    appearance: none;
    width: 110px;
    height: 4px;
    border-radius: 2px;
    background: rgba(255, 255, 255, 0.35);
    outline: none;
    cursor: pointer;

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background: #007bff;
      cursor: pointer;
    }

    &::-moz-range-thumb {
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background: #007bff;
      cursor: pointer;
      border: none;
    }
  `,

  WatermarkSliderValue: styled('span')`
    color: rgba(255, 255, 255, 0.75);
    font-size: 11px;
    min-width: 32px;
    text-align: right;
  `,

  WatermarkDivider: styled('div')`
    width: 100%;
    height: 1px;
    background: rgba(255, 255, 255, 0.2);
    margin: 2px 0;
  `
};
